export const Copy = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M2.335 12.358c0 .977.792 1.77 1.769 1.77h1.769v-1.18h-1.77a.59.59 0 0 1-.589-.59V4.104a.59.59 0 0 1 .59-.59h8.255a.59.59 0 0 1 .59.59v1.769H7.641c-.977 0-1.77.792-1.77 1.769v8.254c0 .977.793 1.769 1.77 1.769h8.254c.977 0 1.769-.792 1.769-1.769V7.642c0-.977-.792-1.77-1.769-1.77h-1.769V4.105c0-.977-.792-1.769-1.769-1.769H4.104c-.977 0-1.769.792-1.769 1.769v8.255Zm4.717-4.716a.59.59 0 0 1 .59-.59h8.254a.59.59 0 0 1 .59.59v8.254a.59.59 0 0 1-.59.59H7.642a.59.59 0 0 1-.59-.59V7.642Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
